import React, { FC } from 'react';

type Props = {
  preview?: boolean;
};

const BuyContainer: FC<Props> = ({ children }) => (
  <div className="space-y-10 md:flex md:items-stretch md:justify-end md:space-y-none md:pt-15 Buy-Container">
    {children}
  </div>
);

export default BuyContainer;
